module.exports = __webpack_public_path__ + "img/chevron_down.ea986f39.svg";